import SummaryTableWrapper from '../SummaryTableWrapper';
import SummaryTableRow from '../SummaryTableRow';
import { Box, Text } from 'native-base';
import SummaryTableRowData from '../SummaryTableRowData';
import React, { memo, useCallback } from 'react';
import ExpandableSummaryRow from '../ExpandableSummaryRow';
const SummaryTable = _ref => {
  let {
    breakouts
  } = _ref;
  const RenderRowCallback = useCallback(breakout => {
    const {
      type
    } = breakout;
    if (type === 'MONTHLY_TOTAL') {
      return /*#__PURE__*/React.createElement(SummaryTableRow, {
        key: type,
        borderColor: "black",
        borderBottomWidth: 0,
        borderTopWidth: 1,
        borderTopColor: "black",
        id: type
      }, /*#__PURE__*/React.createElement(SummaryTableRowData, {
        key: breakout.description,
        title: breakout.description,
        previous: breakout.previousPaymentAmount,
        current: breakout.currentPaymentAmount,
        difference: breakout.difference,
        fontWeight: 'bold'
      }));
    }
    if (Array.isArray(breakout.paymentSubComponentBreakouts) && breakout.paymentSubComponentBreakouts.length) {
      return /*#__PURE__*/React.createElement(ExpandableSummaryRow, {
        key: breakout.description,
        rows: breakout.paymentSubComponentBreakouts,
        title: breakout.description,
        previous: breakout.previousPaymentAmount,
        current: breakout.currentPaymentAmount,
        difference: breakout.difference
      });
    }
    return /*#__PURE__*/React.createElement(SummaryTableRow, {
      id: type,
      key: type
    }, /*#__PURE__*/React.createElement(SummaryTableRowData, {
      key: breakout.description,
      title: breakout.description,
      previous: breakout.previousPaymentAmount,
      current: breakout.currentPaymentAmount,
      difference: breakout.difference
    }));
  }, []);
  return /*#__PURE__*/React.createElement(SummaryTableWrapper, {
    key: 'escrow-summary-table'
  }, /*#__PURE__*/React.createElement(SummaryTableRow, {
    bg: "#21478133",
    id: 'table-heading',
    key: 'escrow-table-heading'
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 2
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontSize: {
      base: 'sm',
      md: 'md',
      lg: 'md'
    },
    fontWeight: "500",
    accessibilityLabel: "current",
    accessibilityRole: "text"
  }, "Current")), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'md',
      lg: 'md'
    },
    fontWeight: "500",
    accessibilityLabel: "new",
    accessibilityRole: "text"
  }, "New"))), /*#__PURE__*/React.createElement(React.Fragment, null, !breakouts || !Array.isArray(breakouts) ? /*#__PURE__*/React.createElement(Box, null) : breakouts.map(RenderRowCallback)));
};
export default /*#__PURE__*/memo(SummaryTable);
//# sourceMappingURL=index.js.map